import { Typography } from '@material-ui/core'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useStaticQuery, graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Form,
  FormControl,
  Image,
  Nav,
  Navbar,
  NavDropdown,
  Row,
} from 'react-bootstrap'

import ArrowLeft from '../../images/icons/arrow_left.svg'
import CloseIcon from '../../images/icons/close2.svg'
import HamburgerIcon from '../../images/hamburger_icon.svg'
import SashFlat from '../../images/sashFlat1ColorDphBluePms281White.png'

import Banner from '../Banner'
import ButtonComponentTwoLines from '../ButtonComponentTwoLine'
import LanguageModal from '../LanguagesModal'
import { languages } from '../../utils/languages'
import '../../styles/navbar.css'
import '../../styles/menuItemsIcons.css'

import { useStyles } from './styles'

const Header = ({ handleHeader }) => {
  const classes = useStyles()
  const location = useLocation()
  const [isNavbarOpen, setNavbarState] = useState(false)
  const [open, setOpen] = useState(false)
  const [language, setLanguage] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  const [isLoaded, setLoaded] = useState(false)
  const [search, setSearch] = useState('')

  const data = useStaticQuery(graphql`
    {
      wpcontent {
        generalSettings {
          url
        }
        menu(id: "dGVybToy") {
          menuItems(where: { parentDatabaseId: 0 }) {
            nodes {
              url
              id
              label
              cssClasses
              childItems {
                nodes {
                  id
                  label
                  url
                }
              }
            }
          }
        }
      }
    }
  `)
  const { url } = data.wpcontent.generalSettings
  const items = data.wpcontent.menu.menuItems.nodes.map((item) => {
    return {
      ...item,
      url: item.url.replace(url, ''),
    }
  })

  useEffect(() => {
    const fetch = () => {
      const lang = window.Weglot.getCurrentLang()
      setLanguage(lang)
      setIsMobile(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent))
      setLoaded(true)
      const searchButton = document.getElementById('search-button')
      searchButton.addEventListener('keydown', function (e) {
        if (e.code === 'Enter') {
          searchFunction()
        }
      })
    }

    setTimeout(() => fetch(), 400)
  }, [])

  const goBack = (e) => {
    e.preventDefault()
    setOpen(false)
    navigate(-1)
  }

  const changeLanguage = (code) => {
    window.Weglot.on('languageChanged', (newLang) => {
      if (newLang === code) {
        window.location.reload()
      }
    })

    window.Weglot.switchTo(code)

    setOpen(false)
  }

  const handleNavbarState = () => {
    setNavbarState(!isNavbarOpen)
    handleHeader(!isNavbarOpen)
  }

  const searchFunction = () => {
    setNavbarState(false)
    const searchTerm = search
    navigate(`/search/?query=${searchTerm}`)
    setTimeout(() => setSearch(''), 300)
  }

  const handleLangPopupState = () => {
    setOpen(false)
  }

  return (
    <div>
      {!isMobile && isLoaded ? <Banner /> : null}
      <Navbar
        collapseOnSelect
        expand="xxl"
        expanded={isNavbarOpen}
        style={!isMobile && isLoaded ? { marginTop: '36px' } : null}
      >
        <div className="navbar-side">
          {location.pathname !== '/' ? (
            <Button
              className="button-nav"
              aria-label="Go back to the main page"
              aria-controls="responsive-navbar-nav"
              onClick={goBack}
            >
              <Image className="back-button" src={ArrowLeft} />
            </Button>
          ) : (
            <div className="button-nav" />
          )}
        </div>
        <Navbar.Brand href="/" className="no_translate">
          <strong
            id="main"
            className="logo-recover"
            role="heading"
            aria-level="1"
          >
            RECOVER
          </strong>{' '}
          LA
        </Navbar.Brand>
        <div className="navbar-side">
          <Navbar.Toggle
            onClick={handleNavbarState}
            className="navbar-dark"
            aria-controls="responsive-navbar-nav"
          >
            {isNavbarOpen ? (
              <img role="none" alt="" className="closeIcon" src={CloseIcon} />
            ) : (
              <img role="none" alt="" src={HamburgerIcon} />
            )}
          </Navbar.Toggle>
        </div>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Form
              inline
              className="search-area"
              onSubmit={(event) => event.preventDefault()}
            >
              <FormControl
                type="text"
                className="inputSearch mr-sm-2"
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(ev) => {
                  if (ev.charCode === 13) {
                    searchFunction()
                  }
                }}
                value={search}
                aria-label="Search"
              />
              <button
                id="search-button"
                style={{
                  textDecoration: 'none',
                }}
                className={classes.buttonLine}
                onClick={searchFunction}
              >
                <Typography className={classes.buttonText}>SEARCH</Typography>
              </button>
            </Form>

            <Button
              className="lang-button no_translate"
              onClick={() => setOpen(true)}
            >
              <img
                role="none"
                alt="language-flag"
                src={
                  language && language !== ''
                    ? languages.find((lang) => lang.code === language).flag
                    : null
                }
                className="lang-flag d-none"
              />
              {language && language !== ''
                ? languages.find((lang) => lang.code === language).name
                : ''}
            </Button>

            {items.map((item, index) => (
              <NavDropdown
                key={index}
                className={item.cssClasses}
                title={item.label.toLowerCase()}
                style={{ fontFamily: 'Mont-Heavy' }}
                role="navigation"
              >
                {item.childItems.nodes.map((subItem) => (
                  <NavDropdown.Item
                    key={subItem.label.toLowerCase()}
                    className="level2"
                    href={
                      !subItem.url.includes('sud_101/videos')
                        ? subItem.url.replace(url, '')
                        : `${subItem.url.replace(
                            subItem.url,
                            ''
                          )}/sud_101/videos/?lang=${language}`
                    }
                  >
                    {subItem.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            ))}

            <div className="find dropdown nav-item">
              <a
                aria-haspopup="true"
                aria-expanded="false"
                id="collasible-nav-dropdown"
                href="/agencies"
                className="dropdown-toggle nav-link"
                role="button"
              >
                Find a Provider
              </a>
            </div>
            <div className="legal dropdown nav-item">
              <a
                aria-haspopup="true"
                aria-expanded="false"
                id="collasible-nav-dropdown-Legal"
                href="/legal"
                className="dropdown-toggle nav-link"
                role="button"
              >
                Legal
              </a>
            </div>
          </Nav>

          <div className="box-image">
            <Row>
              <Col xs={6}>
                <img
                  role="none"
                  alt=""
                  style={{ width: 146, height: 50, resizeMode: 'contain' }}
                  src={SashFlat}
                />
              </Col>
              <Col xs={6}>
                <ButtonComponentTwoLines
                  url={`1-844-804-7500`}
                  text="Call"
                  type="orange"
                  callToAction="phone"
                  onClick={() =>
                    window.gtag('event', 'click', {
                      helpline_phone: '1-844-804-7500',
                    })
                  }
                />
              </Col>
            </Row>
          </div>
          <div className="box-header-footer">
            <Row>
              <Col xs={12}>
                <p>LA County Substance Abuse Prevention & Control</p>
              </Col>
            </Row>
          </div>
        </Navbar.Collapse>
      </Navbar>
      <LanguageModal
        isOpen={open}
        setClose={changeLanguage}
        languages={languages}
        selectedLang={language}
        cancel={handleLangPopupState}
      />
    </div>
  )
}

export { Header }
